import { PageRequest } from '@/core/request/PageRequest';

import { Manufacturer } from '../Manufacturers/Manufacturers.types';
import { SubGroup } from '../SubGroups/SubGroups.types';
import { IcmsOrigin } from '../../invoice/invoiceNoteItems/invoiceNoteItemsParts/InvoiceNoteItems.types';

export enum PartFlag {
  import = 'IMPORT',
  oldPart = 'OLD_PART',
  newPart = 'NEW_PART',
  convPart = 'CONV_PART',
  integration = 'INTEGRATION',
}
export interface Part {
  anpCode?: string;
  anpDescription?: string;
  active: boolean;
  flag: PartFlag;
  barCode: string;
  cfopId: number;
  comment: string;
  id: number;
  imageUrl: string;
  includeInDiagnosis: boolean;
  kmToMaintenance: number;
  lifespan: number;
  localizaCode: string;
  icmsOrigin: IcmsOrigin;
  manufacturer: Manufacturer;
  manufacturingCode: string;
  matrixId: number;
  name: string;
  ncmId: number;
  sku: string;
  subGroup: SubGroup;
  unit: string;
  unitAlternative: string;
  unitConversionFactor: number;
}

export interface PartsQuery extends PageRequest {
  id?: number;
  active?: boolean;
  applicationFreeDescription?: string;
  applicationYear?: number;
  barCode?: string;
  brandId?: number;
  comment?: string;
  manufacturingCode?: string;
  matrixId?: number;
  modelId?: number;
  name?: string;
  sku?: string;
  nameFilterType?: 'STARTS' | 'CONTAINS' | 'FULL';
}

export interface CreatePartRequest {
  active?: boolean;
  anpCode?: string;
  anpDescription?: string;
  flag: PartFlag;
  barCode?: string;
  cfopId?: number;
  copyId?: number;
  comment?: string;
  imageUrl?: string;
  includeInDiagnosis: boolean;
  kmToMaintenance?: number;
  lifespan?: number;
  localizaCode?: string;
  manufacturerId?: number;
  manufacturingCode?: string;
  name: string;
  ncmId?: number;
  sku?: string;
  subGroupId: number;
  unit: string;
  unitAlternative?: string;
  unitConversionFactor?: number;
  partStockSet?: {
    companyId: 0;
    quantity: 0;
  }[];
}

export interface UpdatePartRequest {
  active?: boolean;
  flag: PartFlag;
  barCode?: string;
  cfopId?: number;
  comment?: string;
  id: number;
  imageUrl?: string;
  includeInDiagnosis: boolean;
  kmToMaintenance?: number;
  lifespan?: number;
  localizaCode?: string;
  manufacturerId?: number;
  manufacturingCode?: string;
  name: string;
  ncmId?: number;
  sku?: string;
  subGroupId: number;
  unit: string;
  unitAlternative?: string;
  unitConversionFactor?: number;
}

export interface PartCreateMultipleRequest {
  partRequestDTOList: CreatePartRequest[];
}
